import React, { ReactNode } from 'react';

import { Footer } from 'components/Footer';

import { FormProps } from '../../interfaces';

type attachmentItem = {
  title: string;
  link: string;
};

interface Props {
  children?: ReactNode;
  className?: string;
  content: ReactNode;
  attachments: attachmentItem[];
  socialMediaUrls: string[];
  layoutClass: string;
}

const Layout: React.FC<Props & FormProps> = ({
  children,
  className = '',
  content,
  attachments,
  socialMediaUrls,
  layoutClass = '',
}) => {
  return (
    <div className={layoutClass}>
      <main role="main" className={className}>
        {children}
      </main>
      {content}
      <Footer attachments={attachments} socialMediaUrls={socialMediaUrls} />
    </div>
  );
};

export default Layout;
